import NationalitiesIndex from '@/views/settings/nationalities/NationalitiesIndex.vue';
import NationalityAdd from '@/views/settings/nationalities/NationalityAdd.vue';
import NationalityEdit from '@/views/settings/nationalities/NationalityEdit.vue';

export default [
  {
    path: '/settings/nationalities',
    name: 'settings.nationalities.index',
    component: NationalitiesIndex,
    meta: { title: 'settings.nationalities.indexTitle', requiresAuth: true, requiredPerm: 'nationalities.display' },
    children: [
      {
        path: 'add',
        name: 'settings.nationalities.create',
        component: NationalityAdd,
        meta: { title: 'settings.nationalities.addTitle', requiresAuth: true, requiredPerm: 'nationalities.create' }
      },
      {
        path: 'edit/:id',
        name: 'settings.nationalities.edit',
        component: NationalityEdit,
        props: true,
        meta: { title: 'settings.nationalities.editTitle', requiresAuth: true, requiredPerm: 'nationalities.update' }
      }
    ]
  }
];
